/*
 * @Description: 资金管理模块
 * @Author: Harry
 * @Date: 2020-12-28 13:48:01
 * @LastEditTime: 2020-12-28 17:56:03
 * @LastEditors: Harry
 */
import i18n from "@/locales";

export default [
  //资金管理前置页 
  {
    path: "/funds-management-pre",
    name: "funds-management-pre",
    component: () => import("@/views/funds-management/pre_index.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[6]")
    }
  },	
  //资金管理首页
  {
    path: "/funds-management",
    name: "funds-management",
    component: () => import("@/views/funds-management/index.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[0]")
    }
  },
  //资金详情
  {
    path: "/funds-details",
    name: "funds-details",
    component: () => import("@/views/funds-management/FundsDetails.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[1]")
    }
  },
  //银行卡列表
  {
    path: "/bank-card-list",
    name: "bank-card-list",
    component: () => import("@/views/bank-card/List.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("bankCard.pageTitle[0]")
    }
  },
  //银行卡添加
  {
    path: "/bank-card-add",
    name: "bank-card-add",
    component: () => import("@/views/bank-card/Add.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("bankCard.pageTitle[1]")
    }
  },
  //
  {
    path: "/transfer-into-index",
    name: "transfer-into-index",
    component: () => import("@/views/funds-management/TransferIntoIndex.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[2]")
    }
  },
  {
    path: "/transfer-into-inland",
    name: "transfer-into-inland",
    component: () => import("@/views/funds-management/TransferIntoInland.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[3]")
    }
  },
  {
    path: "/transfer-into-hk-index",
    name: "transfer-into-hk-index",
    component: () => import("@/views/funds-management/TransferIntoHKIndex.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[2]")
    }
  },
  {
    path: "/transfer-into-abroad",
    name: "transfer-into-abroad",
    component: () => import("@/views/funds-management/TransferIntoAbroad.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[3]")
    }
  },
  {
    path: "/credentials-upload",
    name: "credentials-upload",
    component: () => import("@/views/funds-management/CredentialsUpload.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[4]")
    }
  },
  {
    path: "/funds-order-detail",
    name: "funds-order-detail",
    component: () => import("@/views/funds-management/FundsOrderDetails.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[5]")
    }
  },
  {
    path: "/withdraw",
    name: "withdraw",
    component: () => import("@/views/Withdraw.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("withdraw.nav_title")
    }
  },
  {
    path: "/transfer",
    name: "transfer",
    component: () => import("@/views/Transfer.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[8]")
    }
  },
  //资金管理首页
  {
    path: "/transfer-record",
    name: "transfer-record",
    component: () => import("@/views/funds-management/transferRecord.vue"),
    meta: {
      showHeader: true,
      title: i18n.t("funds.pageTitle[7]")
    }
  },
];
